const NeighborLength = 32;
export const getMatchedSegments = (keyword: string, fullText: string) => {
    const segments: [string, string, string][] = [];
    const kwlength = keyword.length;
    let offset = 0;
    const lcFullText = fullText.toLowerCase();
    const lcKeyword = keyword.toLowerCase();
    while(true) {
        const start = lcFullText.indexOf(lcKeyword, offset);
        if (start < 0) {
            break;
        }
        const prefix = fullText.slice(start - NeighborLength, start);
        const realKeyword = fullText.slice(start, start + kwlength);
        const suffix = fullText.slice(start + kwlength, start + kwlength + NeighborLength);
        segments.push([prefix, realKeyword, suffix]);
        offset = start + kwlength + NeighborLength;
    }
    return segments;
}